import { CommonValue } from "./CommonValue";

class HepatitisB extends CommonValue {
    public IsAcute: boolean;
    public IsCarrier: boolean;

    constructor(fields?: Partial<HepatitisB>) {
        super(fields);
        Object.assign(this, fields);
    }
}

export { HepatitisB };
